// extracted by mini-css-extract-plugin
export default {"card":"CoachSaysCard_card__MbGry","label":"CoachSaysCard_label__1IsgS","line":"CoachSaysCard_line__s7hku"};